export const LAST_FOUR_LENGTH = 4;

export enum CreditCardScheme {
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD',
    AMEX = 'AMEX',
    DINERS = 'DINERS',
    JCB = 'JCB',
}


export const PREFIX_LENGTH_BY_SCHEME: Record<CreditCardScheme, number> = {
    [CreditCardScheme.VISA]: 8,
    [CreditCardScheme.MASTERCARD]: 8,
    [CreditCardScheme.DINERS]: 8,
    [CreditCardScheme.AMEX]: 6,
    [CreditCardScheme.JCB]: 6,
};

export const MAX_PREFIX_LENGTH = 8;

export const SCHEME_DISPLAY_NAMES: Record<CreditCardScheme, string> = {
    [CreditCardScheme.VISA]: 'Visa',
    [CreditCardScheme.MASTERCARD]: 'Mastercard',
    [CreditCardScheme.AMEX]: 'American Express',
    [CreditCardScheme.DINERS]: 'Diners Club',
    [CreditCardScheme.JCB]: 'JCB',
};

export const PLACEHOLDER_PREFIX_BY_SCHEME: Record<CreditCardScheme, string> = {
    [CreditCardScheme.VISA]: '40000000',
    [CreditCardScheme.MASTERCARD]: '51000000',
    [CreditCardScheme.AMEX]: '340000',
    [CreditCardScheme.DINERS]: '36000000',
    [CreditCardScheme.JCB]: '352800',
};
